export default "__VITE_ASSET__OY6274TH__"